"use strict";
/**
 * External / cross-subject programmes commonly delivered in UK primary
 * schools (with a Cheshire East lens). Tiered `basics` vs `premium` for the
 * marketplace; premium typically includes branded partnerships (NSPCC,
 * Bikeability, Red Cross) and locality-specific packs (Crucial Crew).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEORY_ONLY_PROGRAMMES = exports.PROGRAMMES_BY_TIER = void 0;
exports.getProgrammeLabel = getProgrammeLabel;
exports.getProgrammeTier = getProgrammeTier;
exports.isTheoryOnlyProgramme = isTheoryOnlyProgramme;
exports.PROGRAMMES_BY_TIER = {
    basics: [
        'think_road_safety',
        'safer_internet_day',
        'daily_mile',
        'swimming',
    ],
    premium: [
        'bikeability_level_1',
        'bikeability_level_2',
        'bikeability_level_3',
        'crucial_crew',
        'nspcc_pants',
        'red_cross_first_aid',
        'fire_service_visit',
        'forest_school',
        'young_carers_network',
    ],
};
const PROGRAMME_LABELS = {
    think_road_safety: 'Think! Road Safety',
    safer_internet_day: 'Safer Internet Day',
    daily_mile: 'The Daily Mile',
    swimming: 'Swimming & Water Safety',
    bikeability_level_1: 'Bikeability — Level 1 (Theory)',
    bikeability_level_2: 'Bikeability — Level 2 (Theory)',
    bikeability_level_3: 'Bikeability — Level 3 (Theory)',
    crucial_crew: 'Crucial Crew (Cheshire East)',
    nspcc_pants: 'NSPCC Talk PANTS',
    red_cross_first_aid: 'Red Cross — First Aid Basics',
    fire_service_visit: 'Fire Service Visit',
    forest_school: 'Forest School',
    young_carers_network: 'Young Carers Network',
};
/**
 * Programmes that deliver practical/physical experiences beyond what an app
 * can capture. Any kit tagged with one of these should show an in-app banner
 * so teachers and parents don't mistake the theory pack for the real thing.
 */
exports.THEORY_ONLY_PROGRAMMES = [
    'bikeability_level_1',
    'bikeability_level_2',
    'bikeability_level_3',
    'swimming',
    'daily_mile',
    'forest_school',
    'fire_service_visit',
    'crucial_crew',
];
function getProgrammeLabel(p) {
    return PROGRAMME_LABELS[p];
}
function getProgrammeTier(p) {
    return exports.PROGRAMMES_BY_TIER.basics.includes(p) ? 'basics' : 'premium';
}
function isTheoryOnlyProgramme(p) {
    return exports.THEORY_ONLY_PROGRAMMES.includes(p);
}
